import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import HomeView from '../views/HomeView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/ramp',
    name: 'ramp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ramp" */ '../views/RampView.vue'),
  },
];

const router = createRouter({
  // history: createWebHashHistory(),
  // history: createWebHistory(),
  history:
    process.env.VUE_APP_ENV === 'production'
      ? createWebHistory()
      : createWebHashHistory(),
  routes,
});

// 这里去除所有路由参数
router.afterEach((item) => {
  process.env.VUE_APP_ENV === 'production'
    ? history.replaceState('', '', `${location.origin}${location.pathname}`)
    : history.replaceState('', '', `${location.origin}${location.pathname}${location.hash}`);

  // history.replaceState('', '', `${location.origin}${location.pathname}`);
});

export default router;
